export default __webpack_public_path__ + "static/media/branding-logo.f1eefc35.svg";